import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import { isIE } from '../../utils/helper';

export const PageSizerContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;

  &.headerSizer {
    align-items: center;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    padding: 0 2rem;
    z-index: 1;
    ${() => isIE() ? `width: 100%;` : ``}
  }
  &.mainContainer {
    ${() => isIE() ? `
      flex: 1 1 auto;
      background-color: #f6f9fc;
      ` :
      `flex: 1;`}
    padding: 2rem 0;
    align-items: center;
    justify-content: center;
    display: flex;
    flex-direction: column;
    width: 80%;

    ${breakpoint('tablet')`
      padding: 0;
    `}
  }
`;



// WEBPACK FOOTER //
// ./src/components/PageSizer/styledComponents.js